
import Vue from "vue";
import {IBreadCrumb, ISelectItem} from "winfakt-vue-components";
import {UserConfigService} from "@/services";
import VueI18n from "vue-i18n";
import AppCalendarEventReminders from "@/components/calendar/CalendarEventReminders.vue";
import { CalendarEventReminder } from "@/models/calendar-event-reminder";
import { requestNotificationPermission } from "@/utils/notifications";
import { GetColorMethod } from "@/models/calendar-event";
import { getEnumKeys, getEnumValueFromKey } from "@/utils/enum";

export default Vue.extend({
	data(){
		return {
			settings: UserConfigService.getCalendarSettings()
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings",
					value: this.$ct("general"),
				},
				{
					value: this.$ct("calendar"),
				},
			] as IBreadCrumb[];
		},
		eventLengths(): ISelectItem<number>[] {
			let d = Object.entries(this.$ct("calendar-settings.default-event-length-items") as any as VueI18n.TranslateResult[]);
			return d.map(s => {
				return {
					text: s[1],
					value: parseFloat(s[0])
				};
			});
		},
		saleEventColorMethods(): ISelectItem<string>[] {
			return getEnumKeys(GetColorMethod).map(k => {
				return {
					text: this.$t(`components.calendar.get-color-method.${k}`),
					value: getEnumValueFromKey(GetColorMethod, k)
				} as ISelectItem<string>;
			});
		},
		firstDaysOfWeek(): ISelectItem<number>[] {
			let d = Object.entries(this.$ct("calendar-settings.first-day-of-week-items") as any as VueI18n.TranslateResult[]);
			return d.map(s => {
				return {
					text: s[1],
					value: parseFloat(s[0])
				};
			});
		},
	},
	methods: {
		async save(){
			await UserConfigService.setCalendarSettings(this.settings);
			this.$wf.notify(this.$ct("save-success").toString(), "success", 3000, "check");
		},
		addReminder() {
			this.settings.DefaultReminders.push(new CalendarEventReminder());
			requestNotificationPermission();
		},
		removeReminder(reminder:CalendarEventReminder) {
			let index = this.settings.DefaultReminders.indexOf(reminder);
			if (index == -1) return;
			this.settings.DefaultReminders.splice(index, 1);
		}
	},
	components: {
		AppCalendarEventReminders
	},
	i18nEx: {
		componentPrefix: "components.settings-default",
	},
});
